import React, { useState, useEffect } from 'react';

import { Row, Divider, Form, Input, Button, Tooltip } from 'antd';
import { MinusCircleOutlined, PlusOutlined, EyeOutlined, EyeInvisibleOutlined, DeleteOutlined } from '@ant-design/icons';

import ColorPreview from './ColorPreview';

import getColors from 'get-image-colors'

import '../index.css';

const ColorPalette = (props) => {



    return (

        <Form name="dynamic_form_item"

            onValuesChange={(event) => {
                props.setColors(event.colors);
                
            }} >
            <div className='jupapi'>
                <center>
                    <Form.List
                        // initialValue = {props.colors[0][0]}
                        name="colors"
                        rules={[
                            {
                                validator: async (_, names) => {
                                    console.log("The names are", names);
                                    if (!names || names.length < 1) {
                                        return Promise.reject(new Error('Select a color'));
                                    }
                                },
                            },
                        ]}
                    >

                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item


                                        //label={index === 0 ? 'Colors' : ''}
                                        required={false}
                                        key={field.key}
                                    >
                                        <Row justify="center">
                                        <Tooltip title="Show/Hide Layer">
                                            {fields.length > 1 && props.colors[index][1] == false ? (
                                                <EyeInvisibleOutlined
                                                    className="dynamic-delete-button"
                                                    onClick={() => {
                                                        var newColors = Object.assign([], props.colors);
                                                        newColors[index][1] = !newColors[index][1];
                                                        props.setColors(newColors)
                                                        console.log("fields, ", fields);
                                                    }}
                                                />
                                            ) : null}
                                            {fields.length > 1 && props.colors[index][1] == true ? (
                                                <EyeOutlined
                                                    className="dynamic-delete-button"
                                                    onClick={() => {
                                                        var newColors = Object.assign([], props.colors);
                                                        newColors[index][1] = !newColors[index][1];
                                                        props.setColors(newColors)
                                                    }}
                                                />
                                            ) : null}
                                            </Tooltip>
                                            {fields.length > 0 ? (
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: "#" + props.colors[index][0], width: "35px", height: "35px" }}></div>
                                            ) : null}
                                            <Form.Item
                                                // {...field}
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: "Please input color or delete this field.",
                                                    },
                                                ]}
                                                noStyle
                                            >
                                                <Input placeholder="Color" style={{ width: 'calc(90% - 100px)' }} value={props.colors[index][0]} />
                                                {/* <div id={"previewColor"+field.key} style={{ backgroundColor: "#fff2f2", display: "inline-block", width: "50px", height: "15px" }} ></div> */}

                                            </Form.Item>


                                            {fields.length > 1 ? (
                                                <DeleteOutlined
                                                    className="dynamic-delete-button"
                                                    onClick={() => remove(field.name)}
                                                />
                                            ) : null}
                                        </Row>

                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Row>

                                        <Button
                                            id='addColor'
                                            type="dashed"
                                            onClick={() => {
                                                console.log("clicked color", props.clickedColor);
                                                add([document.getElementById("status").innerHTML.slice(1), true], 0);
                                            }}
                                            style={{ width: '90%' }}
                                            icon={<PlusOutlined />}
                                        >
                                                        {/* <div id="color" style={{ margin:"10px", width: "25px", height: "25px" }} ><div id="status" style={{paddingLeft:"30px"}}></div></div> */}

                                            Click Image to Add Color
                                        </Button>
                                    </Row>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </center>
            </div>
            <Divider style={{ margin: '0px' }} />
        </Form>
    );
};

export default ColorPalette;
